import VueRouter from 'vue-router'
import { setupAuthGuards } from '@/utils/router-guards'

const router = new VueRouter({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login.vue'),
      meta: {
        title: '用户登录',
        requiresAuth: false // 登录页面不需要认证
      }
    },
    {
      path: '/',
      component: () => import('@/layout/Layout.vue'),
      redirect: (to) => {
        // 检查用户是否登录来决定重定向位置
        const token = localStorage.getItem('token')
        const tokenExpires = localStorage.getItem('tokenExpires')

        if (token && tokenExpires && Date.now() < parseInt(tokenExpires)) {
          // 已登录，重定向到主页
          return '/digiKey'
        } else {
          // 未登录，重定向到登录页
          return '/login'
        }
      },
      meta: { requiresAuth: true }, // 需要认证的布局
      children: [
        {
          name: 'DigiKey',
          path: 'digiKey',
          component: () => import('@/views/DigiKey.vue'),
          meta: {
            title: '得捷查询',
            requiresAuth: true
          }
        },
        {
          name: 'Favorite',
          path: 'favorite',
          component: () => import('@/views/favorite.vue'),
          meta: {
            title: '数据分析',
            requiresAuth: true
          }
        },
        {
          name: 'History',
          path: 'history',
          component: () => import('@/views/history.vue'),
          meta: {
            title: '数据收藏',
            requiresAuth: true
          }
        },
        {
          name: 'BatchSearch',
          path: 'batchSearch',
          component: () => import('@/views/batchSearch.vue'),
          meta: {
            title: '批量搜索',
            requiresAuth: true
          }
        },
        {
          name: 'AccountManage',
          path: 'accountManage',
          component: () => import('@/views/accountManage.vue'),
          meta: {
            title: '账号管理',
            requiresAuth: true
          }
        },
        {
          name: 'ModelSearch',
          path: 'modelSearch',
          component: () => import('@/views/modelSearch.vue'),
          meta: {
            title: '型号查询',
            requiresAuth: true
          }
        },
        {
          name: 'ModelDetail',
          path: 'modelDetail',
          component: () => import('@/views/modelDetail.vue'),
          meta: {
            title: '型号详情',
            requiresAuth: true
          }
        },
        {
          name: 'GlobalSearch',
          path: 'globalSearch',
          component: () => import('@/views/globalSearch.vue'),
          meta: {
            title: '型号全局搜索',
            requiresAuth: true
          }
        },
        {
          name: 'LeadTime',
          path: 'leadTime',
          component: () => import('@/views/leadTime.vue'),
          meta: {
            title: '交期风险筛查',
            requiresAuth: true
          }
        }
      ]
    },
    {
      // 404页面 - 可选
      path: '*',
      name: 'NotFound',
      redirect: (to) => {
        // 404时也检查登录状态
        const token = localStorage.getItem('token')
        const tokenExpires = localStorage.getItem('tokenExpires')

        if (token && tokenExpires && Date.now() < parseInt(tokenExpires)) {
          return '/digiKey'
        } else {
          return '/login'
        }
      }
    }
  ]
})

// 设置路由守卫
setupAuthGuards(router)

// 全局前置守卫 - 更精确的权限控制
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - DigiKey管理系统`
  } else {
    document.title = 'DigiKey管理系统'
  }

  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要认证的路由
    const token = localStorage.getItem('token')
    const tokenExpires = localStorage.getItem('tokenExpires')

    if (token && tokenExpires && Date.now() < parseInt(tokenExpires)) {
      // 已登录且token未过期
      next()
    } else {
      // 未登录或token过期，跳转到登录页
      console.log('路由需要认证，但用户未登录，跳转到登录页')
      next({
        path: '/login',
        query: {
          redirect: to.fullPath // 保存目标路由，登录后跳转
        }
      })
    }
  } else {
    // 不需要认证的路由（如登录页）
    if (to.path === '/login') {
      // 如果已登录用户访问登录页，跳转到主页
      const token = localStorage.getItem('token')
      const tokenExpires = localStorage.getItem('tokenExpires')

      if (token && tokenExpires && Date.now() < parseInt(tokenExpires)) {
        next('/digiKey')
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

// 全局后置钩子
router.afterEach((to, from) => {
  // 页面跳转完成后的处理
  console.log(`页面跳转完成: ${from.path} → ${to.path}`)

  // 可以在这里添加页面访问统计、加载进度条结束等逻辑
})

export default router
